import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast, Flip } from "react-toastify";
import { createBrowserHistory } from "history";
import "react-toastify/dist/ReactToastify.css";
import {
  SIGNUP_INIT_ACTION,
  FETCH_SIGNUP_SUCCESS_ACTION,
  FETCH_SIGNUP_FAIL_ACTION,
  SENDOTP_SUCCESS_ACTION,
  SENDOTP_FAIL_ACTION,
  FETCH_TnC_INIT_ACTION,
  FETCH_TnC_SUCCESS_ACTION,
  FETCH_TnC_ERROR_ACTION
} from "./action";
import { appConfig } from "../../config";
import { push } from "connected-react-router";

let history = createBrowserHistory();

function* signup(cred) {
  // console.log(cred);
  const signupValue = {
    name: cred.cred.value.fname,
    lName: cred.cred.value.lname,
    fullName:cred.cred.value.fname+" "+cred.cred.value.lname,
    email: cred.cred.value.email,
    country: "5f55e6b69e2b29e675c220b9",
    mobileNo: cred.cred.value.mobileNo,
    password: cred.cred.value.password,
    role: "distributor",
  };

  try {
    const res = yield fetch(`${appConfig.ip}/users`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(signupValue),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_SIGNUP_SUCCESS_ACTION,
        payload: resJSON,
      });
      let distributorID = resJSON.user.id;
      localStorage.setItem("distributorId", distributorID);
      localStorage.setItem("UserRole", resJSON.user.role);
      localStorage.setItem("token", resJSON.token);
      // console.log(resJSON.token);
      localStorage.setItem("userDetails", JSON.stringify(resJSON.user));
      if (resJSON.user.phnCnfrmd === false) {
        try {
          const token = localStorage.getItem("token");
          const data = {};//was {ok:true} earlier
          const res2 = yield fetch(`${appConfig.ip}/phoneVerify/sendotp`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
          });
      
          if (!res2.ok) {
            throw res2;
          } else {
            const res2JSON = yield res2.json();
            yield put({
              type: SENDOTP_SUCCESS_ACTION,
              payload: res2JSON,
            });
            /* yield toast.success("OTP Sent", {
              autoClose: 3000,
            }); */
            yield put(push("/verifyotp"));
          }
        } catch (err) {
          if (err.status === 401) {
            yield toast.error("User denied", {
              autoClose: 3000,
              transition:Flip
            });
          }
      
          yield put({
            type: SENDOTP_FAIL_ACTION,
            payload: err,
          });
        }




      } else if (resJSON.user.phnCnfrmd === true) {
        yield put(push("/dashboard"));
      }

      yield toast.success("Successfully registered", {
        autoClose: 3000,
        transition:Flip
      });
    }
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 409) {
        yield toast.error(err.message, {
          autoClose: 3000,
          transition:Flip
        });
      }
      yield put({
        type: FETCH_SIGNUP_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchtandc() {
  try {
    const res = yield fetch(
      `${appConfig.ip}/tandCS`,
      {
        method: "GET",
      }
    );
    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_TnC_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_TnC_ERROR_ACTION, error: err });
    } else {
    }
  }
}

export function* SignUpActionWatcher() {
  yield takeEvery(SIGNUP_INIT_ACTION, signup);
  yield takeEvery(FETCH_TnC_INIT_ACTION,fetchtandc);
}
